module.exports = __webpack_public_path__ + "static/5-892841ec40c5037292ce681a0fa089af.jpg";